import React, { useState } from 'react'
import InitialStep from 'components/buy/Engraving/Back/InitialStep'
import Text from 'components/buy/Engraving/Text'

const EngravingBack = () => {
  const [step, setStep] = useState('initialstep')

  if (step.toLowerCase() === 'initialstep') return <InitialStep setStep={setStep} />
  if (step.toLowerCase() === 'text') return <Text item="back" setStep={setStep} />
  return <InitialStep setStep={setStep} />
}

export default EngravingBack
